import { flexRow, flexRowEnd } from '../../../common/styles/flex';
import { SITE_VARIABLES } from '../../../common/styles/variables';
import { READ_MORE_HEIGHT_BIG, READ_MORE_HEIGHT_SMALL } from '../../../common/utils/common.constants';

interface StylesObject {
  readMoreContainerStyle: { [key: string]: any };
  readMoreButtonStyle: { [key: string]: any };
  readMoreTextStyle: { [key: string]: any };
  readMoreIconStyle: { [key: string]: any };
}

const readMoreContainer = {
  ...flexRowEnd,
  height: `${READ_MORE_HEIGHT_SMALL}px`,
  bigHeight: {
    height: `${READ_MORE_HEIGHT_BIG}px`,
  },
  width: '100%',
  backgroundColor: SITE_VARIABLES.COLORS.BLACK,
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.TINY,
  pointerEvents: 'auto',
};

const readMoreButton = {
  ...flexRow,
  alignItems: 'center',
  cursor: 'pointer',
  pointerEvents: 'all',
  width: 'fit-content',
  marginRight: '25px',
  disableButton: {
    opacity: '40%',
    pointerEvents: 'none',
    cursor: 'auto',
  },
};

const readMoreText = {
  fontFamily: SITE_VARIABLES.TEXT_FONT_FAMILY.LATO,
  fontWeight: 'bold',
  color: SITE_VARIABLES.COLORS.WHITE,
  display: 'block',
  fontSize: SITE_VARIABLES.FONT_SIZE.EXTRA_SMALL,
  bigFont: {
    fontSize: SITE_VARIABLES.FONT_SIZE.SMALL,
  },
  marginRight: '7px',
  alignSelf: 'center',
  opacity: '80%',
  onHover: {
    opacity: '100%',
  },
};

const readMoreIcon = {
  display: 'inline-flex',
};

export const getReadMoreStyleObject = (adPlaying: boolean, isVideoCompleted: boolean, buttonHovered: boolean,
  mobilePlayerMode: boolean): StylesObject => ({
  readMoreContainerStyle: [
    readMoreContainer,
    mobilePlayerMode && readMoreContainer.bigHeight,
  ],
  readMoreButtonStyle: [
    readMoreButton,
    adPlaying && readMoreButton.disableButton,
    isVideoCompleted && readMoreButton.disableButton,
  ],
  readMoreTextStyle: [
    readMoreText,
    mobilePlayerMode && readMoreText.bigFont,
    buttonHovered && readMoreText.onHover,
  ],
  readMoreIconStyle: {
    ...readMoreIcon,
  },
});
